import { NotAuthorizedPage, Protected } from "@dgs/core";
import * as Sentry from "@sentry/react";
import { FC } from "react";
import { Route, RouterProvider, Routes, createBrowserRouter } from "react-router";
import { AppProviders } from "./AppProviders";
import { JarvisAuthPages } from "./auth";
import { Content } from "./Content";

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const AppRoutes: FC = () => {
	return (
		<AppProviders>
			<SentryRoutes>
				<Route path="/auth/*" element={<JarvisAuthPages />} />
				<Route
					path="/*"
					element={
						<Protected redirectBack={true}>
							<Content />
						</Protected>
					}
				/>
				<Route path="not-authorized" element={<NotAuthorizedPage title="JARVIS" redirect={-1} />} />
			</SentryRoutes>
		</AppProviders>
	);
};

const router = createBrowserRouter([
	{
		path: "*",
		Component: AppRoutes,
	},
]);

export const App: FC = () => {
	return <RouterProvider router={router} />;
};
